import React, { useState } from 'react';
import { Card } from 'antd';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
import { getStorage } from 'utils/storage';
import styled from 'styled-components';

const CardStyled = styled(Card)`
  .ant-card-extra {
    cursor: pointer;
  }
  &.hide-body {
    .ant-card-body {
      display: none;
    }
  }
  &.show-body {
    .ant-card-head {
      color: #fff;
      background-color: #4a5782;
    }
  }
`;

const FAQ = () => {
  const FAQJson = getStorage('locale') === 'en' ? FAQJson_zh : FAQJson_en;
  return (
    <div>
      {FAQJson.map((item, i) => (
        <FAQCard question={item.question} answer={item.answer}></FAQCard>
      ))}
    </div>
  );
};

export default FAQ;

export const FAQCard = (props: { question: string; answer: string }) => {
  const [isSpread, setspread] = useState(false);
  return (
    <CardStyled
      title={
        <span
          style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}
          onClick={() => {
            setspread(!isSpread);
          }}
        >
          {props.question}
        </span>
      }
      bordered={false}
      style={{ marginTop: 16 }}
      className={isSpread ? 'show-body' : 'hide-body'}
      extra={
        <span
          onClick={() => {
            setspread(!isSpread);
          }}
        >
          {isSpread ? <CaretUpOutlined /> : <CaretDownOutlined />}
        </span>
      }
    >
      {props.answer}
    </CardStyled>
  );
};

export const FAQJson_zh: Array<{
  question: string;
  answer: string;
}> = [
  {
    question: '我需要在theme里面添加任何代码吗？',
    answer: '不需要接入任何的代码',
  },
  {
    question: '同一个APP可以同时在app内和Shopify→online store→Prefernces',
    answer: '不可以，一个pixel不能同时填到这两个位置，会造成数据重复记录',
  },
  {
    question: '如何确认pixel已经接入成功了',
    answer:
      '通过安装chrome 应用商店的插件“ facebook pixel helper“ 可以检测是否接入成功',
  },
  {
    question: 'pixel 没有在checkout页面触发，这个正常吗？',
    answer:
      '正常的，shopify 模版限制，没法修改checkout页面代码，但是不影响统计订单成功的信息。',
  },
  {
    question: 'pruchase 传的价格是总的价值吗？',
    answer: '是的，包括产品价格+运费，便于计算总的成本',
  },
  {
    question: '选择Collection 的作用是什么？',
    answer:
      '通过选择指定的collection，pixel只会统计选定的collection里面的数据，便于单独统计某些特定的分类产品数据',
  },
];

export const FAQJson_en: Array<{
  question: string;
  answer: string;
}> = [
  {
    question: 'Do I need to add any code to theme?',
    answer: "You don't have to write any code.",
  },
  {
    question: 'Can more than one position be added to the same Pixel？',
    answer:
      'No, if the same pixel is filled in both positions, the data will be duplicated.',
  },
  {
    question: 'How do I make sure the Pixel has been plugged in successfully?',
    answer:
      'Check the effects with the Facebook Pixel Helper, a plugin for the Chrome App Store.',
  },
  {
    question: 'Pixel did not trigger on the checkout page. Is this normal?',
    answer:
      'As normal, the Shopify template limit prevents you from modifying the Checkout page code, but it does not affect the count of order success.',
  },
  {
    question: 'How is the price of purchase calculated?',
    answer:
      'Yes, it includes the price of the product + freight, so it is easy to calculate the total cost',
  },
  {
    question: 'What is the purpose of selecting a Collection?',
    answer:
      'By selecting a specified collection, Pixel will only count the data within the selected collection, making it easy to separate out the data for certain categories of products',
  },
];
